
import { useRef } from 'react';
import scoreboardBG from '@ihs-widget/assets/dynamicColors/scoreboardBG/scoreboardBG.webp';
import { useScoreboardWidthDynamicFormation } from './hooks/useScoreboardWidthDynamicFormation';
import DynamicShield from '../DynamicShield/DynamicShield';
import { useColorContext } from '@ihs-widget/stores/ColorContext';

interface IOverviewWidgetProps {
    homeTeam: string | number;
    awayTeam: string | number;
    homeFormation: string | null;
    awayFormation: string | null;
}

const ScoreBoardFormationDynamic = ({ homeTeam, awayTeam, homeFormation, awayFormation }: IOverviewWidgetProps) => {
    const { colors } = useColorContext();
    const { 
        maxScoreboardWidth, 
        separatorWidth, 
        homeTeamWidth, 
        awayTeamWidth,
        actualScoreboardWidth
    } = useScoreboardWidthDynamicFormation({ homeTeam, awayTeam });

    const overviewScoreboardHomeTeamRef = useRef<HTMLDivElement>(null);
    const overviewScoreboardAwayTeamRef = useRef<HTMLDivElement>(null);

    return (
        <div className={`h-[88px] min-h-[88px] max-h-[88px] w-full flex justify-between relative`}>
            <div className=' h-full w-full flex justify-center items-center bg-transparent absolute top-0 left-0 right-0 z-10 '
                style={{ backgroundImage: `url(${scoreboardBG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>

                <div className='flex justify-center items-center h-[56px] z-20 bg-[#2B2B2B] rounded-[12px] px-[8px] overflow-hidden'
                    style={{ 
                        maxWidth: `${maxScoreboardWidth}px`,
                        width: `${actualScoreboardWidth}px`
                    }}
                    > 
                    <div ref={overviewScoreboardHomeTeamRef} data-testid={`lineup-scoreboard-team-home`} 
                         className='h-[32px] gap-[4px] flex flex-row justify-end items-center overflow-hidden shrink-0'
                         style={{ width: `${homeTeamWidth + 24 + 4}px`, maxWidth: `${homeTeamWidth + 24 + 4}px` }}
                         > 
                        <div data-testid={`lineup-scoreboard-team-home-shield`} className='relative top-0 left-0 h-full shrink-0'>
                            <DynamicShield color={colors?.homeColor} />
                        </div>
                        <div data-testid={`lineup-scoreboard-team-home-name`} className={`font-medium font-robotoMedium text-[12px] leading-[16px] text-monoY 
                                flex flex-col justify-center items-start overflow-hidden shrink-0`} 
                                style={{ width: `${homeTeamWidth}px`, maxWidth: `${homeTeamWidth}px` }}>
                            <div className='text-left whitespace-nowrap overflow-hidden text-ellipsis w-full' title={String(homeTeam)}>{homeTeam}</div>
                            <div className='text-left whitespace-nowrap overflow-hidden text-ellipsis w-full' title={String(homeFormation)}>{homeFormation}</div>
                        </div>
                    </div>
                    <div className='h-full shrink-0' style={{ width: `${separatorWidth}px` }}></div>
                    <div ref={overviewScoreboardAwayTeamRef} data-testid={`lineup-scoreboard-team-away`} 
                         className='h-[32px] gap-[4px] flex flex-row justify-start items-center  overflow-hidden shrink-0'
                         style={{ width: `${awayTeamWidth + 24 + 4}px`, maxWidth: `${awayTeamWidth + 24 + 4}px` }}>
                          
                        <div data-testid={`lineup-scoreboard-team-away-name`} className={`font-medium font-robotoMedium text-[12px] leading-[16px] text-monoY 
                                flex flex-col justify-center items-end overflow-hidden shrink-0`} 
                                style={{ width: `${awayTeamWidth}px`, maxWidth: `${awayTeamWidth}px` }}>
                            <div className='text-right whitespace-nowrap overflow-hidden text-ellipsis w-full' title={String(awayTeam)}>{awayTeam}</div>
                            <div className='text-right whitespace-nowrap overflow-hidden text-ellipsis w-full' title={String(awayFormation)}>{awayFormation}</div>
                        </div>
                        <div data-testid={`lineup-scoreboard-team-away-shield`} className='relative top-0 right-0 h-full shrink-0'>
                            <DynamicShield color={colors?.awayColor} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScoreBoardFormationDynamic;